import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-055d35b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-background" }

import DropDown from '@/views/EstructuraS/DropDown.vue'
import FloatingTools from '@/views/EstructuraS/FloatingTools.vue';
import PopupWindow from '@/views/EstructuraS/PopupWindow.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PrinPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DropDown),
    _createVNode(FloatingTools),
    _createVNode(PopupWindow)
  ]))
}
}

})